import { Field } from "formik";
import { Form } from "react-bootstrap";
import * as Yup from "yup";
// SubForms
import { NameSubForm, Schema as NameSchema } from '../subforms/Name';
import { ContactSubForm, Schema as ContactSchema } from '../subforms/Contact';
import { OtherInformationSubForm, Schema as OtherInformationSchema } from '../subforms/OtherInformation';
import { SalaryRequestSubForm, Schema as SalaryRequestSchema } from '../subforms/SalaryRequest';
import { EntranceDateSubForm, Schema as EntranceDateSchema } from '../subforms/EntranceDate';
import { DocumentsSubForm, Schema as DocumentsSchema } from '../subforms/Documents';

export const ZiehlAbeggStandardSchema = (settings) => (
    Yup.object()
        .concat(NameSchema(settings))
        .concat(ContactSchema(settings))
        .concat(OtherInformationSchema)
        .concat(SalaryRequestSchema)
        .concat(EntranceDateSchema)
        .concat(DocumentsSchema(settings))
);

export const ZiehlAbeggStandard = (props) => {
    const { colors, settings } = props;
    return (
        <>
            <Form.Text muted>Die im Folgenden mit * markierten Felder sind Pflichtfelder.</Form.Text>
            <Field component={NameSubForm} colors={colors} settings={settings} />
            <Field component={ContactSubForm} colors={colors} settings={settings} />
            <Field component={OtherInformationSubForm} colors={colors} settings={settings} />
            <Field component={SalaryRequestSubForm} colors={colors} settings={settings} />
            <Field component={EntranceDateSubForm} colors={colors} settings={settings} />
            <Field component={DocumentsSubForm} colors={colors} settings={settings} />
        </>
    );
}